import $ from 'qwery';

const getProgressBarEl = (button) => $('[data-el=progressbtn-bar]', button)[0];
const getCompletionClass = (button) => button.getAttribute('data-completionstate');
const getGtmAttribute = (button) => button.getAttribute('data-gtm');

function hideProgressBar (button) {

    const progressBarEl = getProgressBarEl(button);
    const completionClass = getCompletionClass(button);
    const gtmAttribute = getGtmAttribute(button);

    progressBarEl.classList.add('is-hidden');

    button.classList.remove('btn--disabled');
    button.removeAttribute('disabled');

    if (completionClass) {
        button.classList.add(completionClass);
    }

    if (gtmAttribute) {
        const gtmEnabledVal = gtmAttribute.replace('disabled', 'enabled');
        button.setAttribute('data-gtm', gtmEnabledVal);
    }
}

function showProgressBar (button, val, maxVal) {

    const progressBarEl = getProgressBarEl(button);
    const completionClass = getCompletionClass(button);
    const gtmAttribute = getGtmAttribute(button);
    const percentageComplete = (val / maxVal) * 100;

    progressBarEl.classList.remove('is-hidden');
    progressBarEl.style.width = `${percentageComplete}%`;

    button.classList.add('btn--disabled');
    button.setAttribute('disabled', 'disabled');

    if (completionClass) {
        button.classList.remove(completionClass);
    }

    if (gtmAttribute) {
        const gtmDisabledVal = gtmAttribute.replace('enabled', 'disabled');
        button.setAttribute('data-gtm', gtmDisabledVal);
    }
}

export default function update (buttonSelector, val, maxVal) {

    const buttons = $(buttonSelector);

    if (buttons.length > 0) {
        buttons.forEach(button => {

            if (val >= 0) {
                if (val >= maxVal) {
                    hideProgressBar(button);
                } else {
                    showProgressBar(button, val, maxVal);
                }

                button.setAttribute('data-value', val);
                button.setAttribute('data-max', maxVal);
            }

        });
    }

}

window.ProgressButton = {
    update
};
